import { useEffect } from 'react';
import { createRootRoute, Outlet, useMatches } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { bootAuth } from '@/lib/auth';
import { bootGithubLink } from '@/lib/github-link';
import { queryClient } from '@/lib/query-client';

/**
 * Root route for `apps/desktop`.
 *
 * - Boots the deep-link auth handler exactly once (idempotent).
 * - Hosts the `<Outlet />` so child routes render either inside the AppShell
 *   (authed routes mount it themselves) or full-bleed (signin).
 * - Includes the TanStack Router devtools in development for inspecting the
 *   route tree.
 */
function RootComponent() {
  useEffect(() => {
    void bootAuth();
    const unsub = bootGithubLink(queryClient);
    return unsub;
  }, []);

  // Touching `useMatches` here ensures the route tree is wired correctly
  // before children render — useful while the route tree is small.
  useMatches();

  return (
    <>
      <Outlet />
      {import.meta.env.DEV ? <TanStackRouterDevtools position="bottom-right" /> : null}
    </>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
